// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Gothic+A1&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bold_text_wrapper {
  width: 100%;
  margin: 100px 0 60px 0;
}

.bold_text_p {
  color: #666768;
  text-align: center;
  font-family: 'Gothic A1';
  font-size: 115px;
  font-style: normal;
  line-height: 125px;
  font-weight:900;
  letter-spacing: 5px;
  text-transform: uppercase;
  background-image: linear-gradient(180deg, #fff 50%, #666768 50%);
  background-size: 100% 200%;
  background-position: 0 100%;
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.bold_text_p.animate {
  animation: gradientAnimation 4s ease forwards;
}

@keyframes gradientAnimation {
  0% {
    background-position: 0 100%;
  }
  100% {
    background-position: 0 0;
  }
}









@media screen and (max-width: 1200px) {

  .bold_text_wrapper {
    width: 100%;
    margin: 100px 0 60px 0;
  }
  
  .bold_text_p {
    font-size: 105px;
    line-height: 110px;
    font-weight:1000;
    letter-spacing: 4px;
  }

}








@media screen and (max-width: 1024px) {

  .bold_text_wrapper {
    width: 100%;
    margin: 150px 0 60px 0;
  }
  
  .bold_text_p {
    font-size: 90px;
    line-height: 100px;
    font-weight:1000;
    letter-spacing: 4px;
  }

}










@media screen and (max-width: 800px) {

  .bold_text_wrapper {
    width: 100%;
    margin: 150px 0 60px 0;
  }
  
  .bold_text_p {
    font-size: 70px;
    line-height: 80px;
    font-weight:1000;
    letter-spacing: 4px;
  }

}










@media screen and (max-width: 600px) {

  .bold_text_wrapper {
    width: 100%;
    margin: 80px 0 40px 0;
  }
  
  .bold_text_p {
    font-size: 50px;
    line-height: 60px;
    font-weight:1000;
    letter-spacing: 4px;
  }

}











@media screen and (max-width: 450px) {

  .bold_text_wrapper {
    width: 100%;
    margin: 50px 0 40px 0;
    padding: 0 16px;
  }
  
  .bold_text_p {
    font-size: 38px;
    line-height: 44px;
    font-weight:bolder;
    letter-spacing: 4px;
    text-align: center;
    padding-left: 10px;
  }

}`, "",{"version":3,"sources":["webpack://./src/components/homePage/boldtext/boldText.css"],"names":[],"mappings":"AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,gEAAgE;EAChE,0BAA0B;EAC1B,2BAA2B;EAC3B,qBAAqB;EACrB,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF;;;;;;;;;;AAUA;;EAEE;IACE,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;;AAEF;;;;;;;;;AASA;;EAEE;IACE,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;;AAEF;;;;;;;;;;;AAWA;;EAEE;IACE,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;;AAEF;;;;;;;;;;;AAWA;;EAEE;IACE,WAAW;IACX,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;;AAEF;;;;;;;;;;;;AAYA;;EAEE;IACE,WAAW;IACX,qBAAqB;IACrB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;EACpB;;AAEF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Gothic+A1&display=swap');\n\n.bold_text_wrapper {\n  width: 100%;\n  margin: 100px 0 60px 0;\n}\n\n.bold_text_p {\n  color: #666768;\n  text-align: center;\n  font-family: 'Gothic A1';\n  font-size: 115px;\n  font-style: normal;\n  line-height: 125px;\n  font-weight:900;\n  letter-spacing: 5px;\n  text-transform: uppercase;\n  background-image: linear-gradient(180deg, #fff 50%, #666768 50%);\n  background-size: 100% 200%;\n  background-position: 0 100%;\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.bold_text_p.animate {\n  animation: gradientAnimation 4s ease forwards;\n}\n\n@keyframes gradientAnimation {\n  0% {\n    background-position: 0 100%;\n  }\n  100% {\n    background-position: 0 0;\n  }\n}\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 1200px) {\n\n  .bold_text_wrapper {\n    width: 100%;\n    margin: 100px 0 60px 0;\n  }\n  \n  .bold_text_p {\n    font-size: 105px;\n    line-height: 110px;\n    font-weight:1000;\n    letter-spacing: 4px;\n  }\n\n}\n\n\n\n\n\n\n\n\n@media screen and (max-width: 1024px) {\n\n  .bold_text_wrapper {\n    width: 100%;\n    margin: 150px 0 60px 0;\n  }\n  \n  .bold_text_p {\n    font-size: 90px;\n    line-height: 100px;\n    font-weight:1000;\n    letter-spacing: 4px;\n  }\n\n}\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 800px) {\n\n  .bold_text_wrapper {\n    width: 100%;\n    margin: 150px 0 60px 0;\n  }\n  \n  .bold_text_p {\n    font-size: 70px;\n    line-height: 80px;\n    font-weight:1000;\n    letter-spacing: 4px;\n  }\n\n}\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 600px) {\n\n  .bold_text_wrapper {\n    width: 100%;\n    margin: 80px 0 40px 0;\n  }\n  \n  .bold_text_p {\n    font-size: 50px;\n    line-height: 60px;\n    font-weight:1000;\n    letter-spacing: 4px;\n  }\n\n}\n\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 450px) {\n\n  .bold_text_wrapper {\n    width: 100%;\n    margin: 50px 0 40px 0;\n    padding: 0 16px;\n  }\n  \n  .bold_text_p {\n    font-size: 38px;\n    line-height: 44px;\n    font-weight:bolder;\n    letter-spacing: 4px;\n    text-align: center;\n    padding-left: 10px;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
